import { billingDollar } from "assets/icons";
import { isCancel } from "axios";
import { LoadingButton } from "components/form";
import CustomModal from "components/modals/CustomModal";
import { getFromLocal } from "config/axiosInstance";
import useShimmer from "hooks/useShrimmer";
import PaymentCardInterface from "pages/payment-response/PaymentCardInterface";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getSubscriptionLinkApi } from "services/subscription";
import MySurveyShrimmer from "shrimmer/Survey/MySurveyShrimmer";
import { isTrue } from "utils/commonHelper";
import { createArray } from "utils/surveyHelper";
import { toastMessage } from "utils/toastMessageHelper";

const SubscriptionPlan = ({
  planListing,
  currentSubscriptionDetail,
  showShimmer,
}) => {
  // const [showShimmer, setShowShimmer] = useShimmer(MySurveyShrimmer);

  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState(null);

  const { t } = useTranslation();

  //************************ Handle All Function ************************//

  //*********************** Handle HTML CODE *************************//

  const subscripitionPaymentHandler = (selectedPlan) => {
    // Only set up the listener if they're attempting to purchase
    // window.addEventListener("beforeunload", unloadCallback);
    setSelectedPlanId(selectedPlan?._id);
    if (isTrue(currentSubscriptionDetail?.isSubscribed)) {
      toastMessage(
        t("BILLING_DETAIL.alreadySubscriptionError"),
        "subscription-payment"
      );
      return;
    } else {
      paymentCheckoutHandler(selectedPlan);
    }
  };

  // Payment Checkout Handler
  const paymentCheckoutHandler = async (planDetail) => {
    try {
      setButtonLoader(true);
      const reqData = {
        token: getFromLocal() || "",
        planId: planDetail?._id,
      };

      const responseData = await getSubscriptionLinkApi(reqData);

      const { status, data, message } = responseData;
      if (status === 200) {
        console.log(data, "Subscription data");
        const url = data?.url;
        window.location.href = url;
      } else {
        toastMessage(message, "error", "checkoutSurvey");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setButtonLoader(false);
    }
  };

  // useEffect(() => {
  //   window.removeEventListener("beforeunload", unloadCallback);
  // }, []);

  return (
    <>
      <div className="billing_plan">
        {/* <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting,
          remaining essentially unchanged. 
        </p> */}

        <div className="billing_card_wrap">
          {/*----- Subscription listing ------*/}

          {showShimmer ? (
            createArray(3).map((index) => showShimmer)
          ) : planListing?.length > 0 ? (
            planListing.map((el) => (
              <div className="billing_card" key={el?._id}>
                <div className="content">
                  <div className="head">
                    <div className="icon_wrap">
                      <img src={billingDollar} alt="" />
                      <img src={billingDollar} alt="" />
                    </div>
                    {/* {Number(el?.percentageValue || 0) > 0 && (
                      <span className="tag">save {el.percentageValue}%</span>
                    )} */}
                  </div>
                  <h4>{el?.price}</h4>
                  <h5>{el?.plan}</h5>
                  {el?.features?.map((item, i) => (
                    <p key={`${item}-${i}`}>{item}</p>
                  ))}
                </div>
                {el.slug !== "basic" && (
                  <div className="button_wrap">
                    <LoadingButton
                      className="w-100"
                      loading={selectedPlanId === el._id && buttonLoader}
                      onClick={() => subscripitionPaymentHandler(el)}
                    >
                      {t("BILLING_DETAIL.buyfor")} {el?.price}{" "}
                      {t("BILLING_DETAIL.SAR")}
                    </LoadingButton>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p>{t("BILLING_DETAIL.noDataFound")}</p>
          )}
        </div>
      </div>

      {/* Payment Card Model */}
      {isPaymentModalOpen && (
        <CustomModal
          className={""}
          show={isPaymentModalOpen}
          handleClose={() => setIsPaymentModalOpen(false)}
        >
          <PaymentCardInterface />
        </CustomModal>
      )}
    </>
  );
};

export default SubscriptionPlan;
